'use client'

import { TPopupInfo } from '@/entities/content'
import { UserType } from '@/entities/user'
import { useDialog } from '@/shared/lib'

import { EmailSentUserDialog } from './email-sent-user-dialog'
import { MainPopup } from './main-popup'

const DIALOG = {
  EMAIL_SENT_USER: 'EMAIL_SENT_USER',
  MAIN_POPUP: 'MAIN_POPUP',
} as const

type MainDialog = keyof typeof DIALOG

type Props = {
  popupInfos: TPopupInfo[]
  pageType: UserType
}

export const MainDialogs = ({ popupInfos, pageType }: Props) => {
  const hasPopup = popupInfos.length > 0

  const { isOpen, open, close } = useDialog<MainDialog>()

  const handleEmailSentUserDialogOpen = () => {
    open(DIALOG.EMAIL_SENT_USER)
  }

  const handleEmailSentUserDialogClose = () => {
    open(DIALOG.MAIN_POPUP, { closeOnOpen: true })
  }

  const handleMainPopupOpen = () => {
    open(DIALOG.MAIN_POPUP)
  }

  const handleMainPopupClose = () => {
    close(DIALOG.MAIN_POPUP)
  }

  return (
    <>
      <EmailSentUserDialog
        isOpen={isOpen(DIALOG.EMAIL_SENT_USER)}
        onOpen={handleEmailSentUserDialogOpen}
        onClose={handleEmailSentUserDialogClose}
      />
      {hasPopup && !isOpen(DIALOG.EMAIL_SENT_USER) && (
        <MainPopup
          isOpen={isOpen(DIALOG.MAIN_POPUP)}
          onOpen={handleMainPopupOpen}
          onClose={handleMainPopupClose}
          popupInfos={popupInfos}
          pageType={pageType}
        />
      )}
    </>
  )
}
